import { render } from "./logo.vue?vue&type=template&id=2e6a977c&scoped=true"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"

import "./logo.vue?vue&type=style&index=0&id=2e6a977c&scoped=true&lang=less"

import exportComponent from "F:\\code\\suplasercut\\suplasercut-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6a977c"]])

export default __exports__